import {
  PatientInquiryControllerApi,
  PatientInquiryStatusUpdate,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface UseUpdatePatientInquiryStatusParams {
  inquiryId: string;
  patientInquiryStatusUpdate: PatientInquiryStatusUpdate;
  xTENANTID?: string;
}

export const useUpdatePatientInquiryStatus = () =>
  useMutationWithLoading(
    async ({
      inquiryId,
      patientInquiryStatusUpdate,
      xTENANTID,
    }: UseUpdatePatientInquiryStatusParams) =>
      await new PatientInquiryControllerApi(getConfigObject()).updateStatus1(
        inquiryId,
        patientInquiryStatusUpdate,
        xTENANTID
      )
  );
